import React from "react";
import { Tooltip } from "antd";

const BacklinkUrlTableCell = props => {
  return (
    <div className="backlink-url">
      <Tooltip title={props["source_title"]}>
        <div className="truncate">
          {props["source_title"]}
        </div>
      </Tooltip>
      <div className="truncate">
        <a href={props["source_url"]} target="_blank" rel="noopener noreferrer">
          {props["source_url"]}
        </a>
      </div>
    </div>
  );
};

export default BacklinkUrlTableCell;
